import { IThoiKhoaBieuResponse } from "../../../model/respone/lop-tin-chi/IThoiKhoaBieuResponse";
import { IThoiKhoaBieuActionTypes } from "../../action-types/tkb/IThoiKhoaBieuActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IThoiKhoaBieuReducer } from "../../reducer-model/tkb/IThoiKhoaBieuReducer";

const iniState: IThoiKhoaBieuReducer = {
  status: eReducerStatusBase.is_not_initialization,
  data: {} as IThoiKhoaBieuResponse,
};

export const thoiKhoaBieuReducer = (
  state: IThoiKhoaBieuReducer = iniState,
  action: IThoiKhoaBieuActionTypes
): IThoiKhoaBieuReducer => {
  switch (action.type) {
    case "THOI_KHOA_BIEU_SELECT_BY_KY_DANG_KY_START":
      return {
        ...state,
        status: eReducerStatusBase.is_loading,
        kyDangKys: action.payload.kyDangKys,
      };
    case "THOI_KHOA_BIEU_SELECT_BY_KY_DANG_KY_SUCCESS":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
        data: action.payload,
      };
    case "THOI_KHOA_BIEU_SELECT_BY_KY_DANG_KY_ERRR":
      return {
        ...state,
        status: eReducerStatusBase.is_completed,
      };
    default:
      return state;
  }
};
